
const variables = {
    server_url: "https://api.kdprod.fr:8080/", reCAPTACHA_SITE_KEY: "6Lee80olAAAAAKx4FbwtomVKr91ISGqmCJZ0pQ0n"
}
export default variables